export type RefreshInterval = {
  label: string;
  value: number;
}

export const OFF: RefreshInterval = { label: "Off", value: 0 };
export const TEN_SECONDS: RefreshInterval = { label: "10 seconds", value: 10000 };
export const THIRTY_SECONDS: RefreshInterval = { label: "30 seconds", value: 30000 };
export const ONE_MINUTE: RefreshInterval = { label: "1 minute", value: 60000 };
export const FIVE_MINUTES: RefreshInterval = { label: "5 minutes", value: 300000 };
export const TEN_MINUTES: RefreshInterval = { label: "10 minutes", value: 600000 };

export const REFRESH_INTERVALS = [
  OFF,
  TEN_SECONDS,
  THIRTY_SECONDS,
  ONE_MINUTE,
  FIVE_MINUTES,
  TEN_MINUTES,
];

export const DEFAULT_REFRESH_INTERVAL = TEN_MINUTES;
